import {GET_GROUP_INFO} from './actionTypes'

const initialState = {
  groupData: '',
  loadingGroupData: false,
  hasErrorGroupData: false,
  isFulfilledGroupData: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GET_GROUP_INFO}_PENDING`:
      return {
        ...state,
        isFulfilledGroupData: false,
        loadingGroupData: true,
        hasErrorGroupData: false,
        groupData: undefined,
      }

    case `${GET_GROUP_INFO}_FULFILLED`:
      return {
        isFulfilledGroupDataGroupData: true,
        loadingGroupData: false,
        hasError: false,
        groupData: action.payload.data,
      }

    case `${GET_GROUP_INFO}_REJECTED`:
      return {
        isFulfilledGroupData: false,
        loadingGroupData: false,
        hasErrorGroupData: true,
        groupData: undefined,
      }

    default:
      return state
  }
}
